export var Labels = {
    paymentOptionDivider: 'or pay with credit card'
};
